import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { ChangeClinicalStatusModalStore } from 'application/niko-facility-order/stores';
import { ChangeClinicalStatusModalTemplate } from 'themes/application/niko-facility-order/components';

@setCurrentView((rootStore, componentProps) => new ChangeClinicalStatusModalStore(rootStore, componentProps), 'changeClinicalStatusModalStore')
@observer
class ChangeClinicalStatusModal extends React.Component {
    render() {
        return <ChangeClinicalStatusModalTemplate {...this.props} />
    }
}

export default ChangeClinicalStatusModal;
